import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Modal } from './ui/Modal';

interface CloseTabModalProps {
  isOpen: boolean;
  tabTitle: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const CloseTabModal: React.FC<CloseTabModalProps> = ({
  isOpen,
  tabTitle,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col items-center text-center gap-4 pt-2">
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-100">
          <AlertTriangle className="text-red-600" size={24} />
        </div>

        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-1">Close "{tabTitle}"?</h3>
          <p className="text-sm text-gray-500">
            All mortgage data and settings entered in this tab will be permanently lost. This action cannot be undone.
          </p>
        </div>

        <div className="flex gap-3 w-full pt-2">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 transition-colors"
          >
            Close Tab
          </button>
        </div>
      </div>
    </Modal>
  );
};
